

function ErrorPage(){
    return (
        <div>
            esta página no existe :(
        </div>
    )
}

export default ErrorPage;